import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class AddWhiteListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/addWhiteDealerList',
      requesterInfo,
    })
  }

  public async AddWhiteDealer(request: any): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
